import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { lockLoanFields, unlockLoanFields } from 'src/actions';
import { useErrorHandler, useLoan } from 'src/hooks';
import Icon from '@mdi/react';
import { mdiLockOutline, mdiLockOpenOutline } from '@mdi/js';
import styles from './index.module.scss';
import { Tooltip } from '@mui/material';
import { useFormContext } from 'react-hook-form';

const FieldLockDataToggle = ({ fieldContractPath, name, disabled }) => {
  const { loanGuid } = useParams();
  const loan = useLoan(loanGuid);
  const dispatch = useDispatch();
  const { setValue } = useFormContext();
  const handleError = useErrorHandler();

  const hasLock = useMemo(() => {
    const fieldLockData = loan.fieldLockData ?? [];
    return fieldLockData.includes(fieldContractPath);
  }, [loan, fieldContractPath]);

  const tooltipTitle = useMemo(() => {
    if (disabled) return 'Field locks are disabled at the moment';
    if (hasLock) return 'Unlock to remove value and use calculated value';
    return 'Lock field to manually input value';
  }, [hasLock, disabled]);

  const toggleFieldLock = async () => {
    if (!fieldContractPath || disabled) {
      return;
    }
    if (!hasLock) {
      try {
        await dispatch(lockLoanFields(loanGuid, [fieldContractPath]));
      } catch (err) {
        console.error(err);
        handleError({
          title: 'Failed to toggle field lock',
          description: err?.response,
        });
      }
    } else {
      try {
        await dispatch(unlockLoanFields(loanGuid, [fieldContractPath]));
        if (name) {
          setValue(name, null);
        }
      } catch (err) {
        console.error(err);
        handleError({
          title: 'Failed to toggle field lock',
          description: err?.response,
        });
      }
    }
  };
  const displayLockIcon = () => {
    if (hasLock) {
      return mdiLockOutline;
    } else {
      return mdiLockOpenOutline;
    }
  };
  return (
    <Tooltip title={tooltipTitle} placement='top' arrow>
      <Icon
        className={disabled ? styles.disabled : styles.fieldLockData}
        path={displayLockIcon()}
        size={1.5}
        onClick={toggleFieldLock}
      />
    </Tooltip>
  );
};

export default FieldLockDataToggle;
